import fiveMinuteGameSource from "../../../../docs/rqt/examples/basic/01-five-minute-game.rqt?raw";
import stateAndChoiceSource from "../../../../docs/rqt/examples/basic/02-state-and-choice.rqt?raw";
import branchingEndingSource from "../../../../docs/rqt/examples/basic/03-branching-ending.rqt?raw";
import cyoaTextGameSource from "../../../../docs/rqt/examples/recipes/cyoa-text-game.rqt?raw";
import campusRelationshipSimSource from "../../../../docs/rqt/examples/recipes/campus-relationship-sim.rqt?raw";
import survivalSimSource from "../../../../docs/rqt/examples/recipes/survival-sim.rqt?raw";

export type RqtExampleGroup = "basic" | "recipe";

export interface RqtExampleCard {
  id: string;
  group: RqtExampleGroup;
  title: string;
  description: string;
  teaches: string;
  tags: string[];
  filename: string;
  sourcePath: string;
  source: string;
}

export interface RqtRoadmapCard {
  id: string;
  title: string;
  description: string;
  tags: string[];
  status: "planned recipe";
}

export const RQT_IMAGE_PLACEHOLDER_NOTE =
  "이미지 경로는 구조 설명용 placeholder입니다. 실제 게임에서 이미지를 보려면 해당 파일을 패키지에 추가해야 합니다.";

export const RQT_EXAMPLE_CARDS: RqtExampleCard[] = [
  {
    id: "five-minute-game",
    group: "basic",
    title: "Five-minute game",
    description: "A compact starter game with metadata, scalar state, one scene, and choices.",
    teaches: "@game, @state, scenes, choices, @var, @(expr), @@",
    tags: ["basic", "scene", "choices", "interpolation"],
    filename: "01-five-minute-game.rqt",
    sourcePath: "docs/rqt/examples/basic/01-five-minute-game.rqt",
    source: fiveMinuteGameSource,
  },
  {
    id: "state-and-choice",
    group: "basic",
    title: "State and choice",
    description: "Numeric state, enum state, clamps, mutableBy, and condition-based choices.",
    teaches: "numeric state, enum state, clamps, mutableBy, @(expr), &",
    tags: ["basic", "state", "clamps", "branches"],
    filename: "02-state-and-choice.rqt",
    sourcePath: "docs/rqt/examples/basic/02-state-and-choice.rqt",
    source: stateAndChoiceSource,
  },
  {
    id: "branching-ending",
    group: "basic",
    title: "Branching ending",
    description: "A small ending pattern using scalar ending state and branch-dependent text.",
    teaches: "condition branches, ending flags, state-dependent text",
    tags: ["basic", "ending", "branches", "state text"],
    filename: "03-branching-ending.rqt",
    sourcePath: "docs/rqt/examples/basic/03-branching-ending.rqt",
    source: branchingEndingSource,
  },
  {
    id: "cyoa-text-game",
    group: "recipe",
    title: "CYOA / text game",
    description: "A branching text game with route state, scalar inventory-like state, and multiple endings.",
    teaches: "branching paths, scalar item state, route state, ending labels",
    tags: ["recipe", "CYOA", "routes", "endings"],
    filename: "cyoa-text-game.rqt",
    sourcePath: "docs/rqt/examples/recipes/cyoa-text-game.rqt",
    source: cyoaTextGameSource,
  },
  {
    id: "campus-relationship-sim",
    group: "recipe",
    title: "Campus relationship sim",
    description: "A safe adult university relationship sim with time, location, affection, and trust.",
    teaches: "adult campus framing, relationship state, time/location enums, affection/trust clamps",
    tags: ["recipe", "campus", "relationship", "safe"],
    filename: "campus-relationship-sim.rqt",
    sourcePath: "docs/rqt/examples/recipes/campus-relationship-sim.rqt",
    source: campusRelationshipSimSource,
  },
  {
    id: "survival-sim",
    group: "recipe",
    title: "Survival sim",
    description: "A survival loop pattern with HP, needs, weather, danger, resources, and clamps.",
    teaches: "hp, hunger/thirst/fatigue, weather/danger enums, resources, clamps",
    tags: ["recipe", "survival", "resources", "clamps"],
    filename: "survival-sim.rqt",
    sourcePath: "docs/rqt/examples/recipes/survival-sim.rqt",
    source: survivalSimSource,
  },
];

export const RQT_ROADMAP_CARDS: RqtRoadmapCard[] = [
  {
    id: "alternate-history",
    title: "Alternate history",
    description: "Planned fictional-country template for year, event flags, and faction influence.",
    tags: ["planned recipe", "fictional factions", "event flags"],
    status: "planned recipe",
  },
  {
    id: "wuxia",
    title: "Wuxia",
    description: "Planned sect, inner power, reputation, and realm progression recipe.",
    tags: ["planned recipe", "sect", "realm"],
    status: "planned recipe",
  },
  {
    id: "simulation-bot",
    title: "Simulation bot",
    description: "Planned schedule, needs, relationship, and repeated-turn state recipe.",
    tags: ["planned recipe", "schedule", "needs"],
    status: "planned recipe",
  },
  {
    id: "mystery",
    title: "Mystery",
    description: "Planned clue, suspect, alibi, and readonly truth-state recipe.",
    tags: ["planned recipe", "clues", "suspects"],
    status: "planned recipe",
  },
  {
    id: "fanwork-template",
    title: "Fanwork / derivative-work template",
    description: "Planned generic rights-safe structure using placeholders instead of real IP names.",
    tags: ["planned recipe", "IP-safe", "placeholders"],
    status: "planned recipe",
  },
];
